(function () {
  'use strict';
  angular.module('MktzapApp.Factories')
    .factory('LoginService', LoginService);

	    LoginService.$inject = ['$resource'];

		 function LoginService ($resource) {
	        return $resource(apiUrl + '/login', { id: '@id' }, {
	            login: { url: apiUrl + '/login', method: 'POST', params: {}, isArray: false, timeout: 5000 },
	            logout: { url: apiUrl + '/logout', method: 'POST', params: {}, isArray: false, timeout: 5000 },
      logLogout: { url: apiUrl + '/log-logout', method: 'POST', params: {}, isArray: false },
	            recoverPassword: { url: baseUrl + '/password/email', method: 'POST', params: {}, isArray: false, timeout: 5000 }
    });
	    }
})();
